var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F65B5C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 13,
    height: 13,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_167_123",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_167_123",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgEAQAAACJ4248AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAAAqo0jMgAAAAlwSFlzAAAAYAAAAGAA8GtCzwAAAAd0SU1FB+cFCQ8kNd56I9gAAAHNSURBVFjDxZcvSANhGMaf91NZEHEGF1YsJgdmXVnRoP0W1iybUQSxaDAI2gTLltaH2YUZvLA/bSDcQLZimDAFFwRBhO8xzAuTufNuu7tfvLv33t/3vR8PfAAAMholTZPs9cizM3J+HkFCZjIcotsl9/ZIpQISyGY5Essid3b87O2wwrU14PaWulIhE4kQBH6QrS2g2SQLBepYbOoWf49gFG9v5PExdSQSkoBNu01tGKSI/yMYyeoqpFQCazVyczMEgR9kYwOoVqlLJeqVleAFBhYCMQxIq0VeXFAvLLgq93YGxtHtDv45MxPQDvwmHgcKBeDhwSnIfI5a5yALJuuHgmx5OXgBAMDcHJDNQh4fqXO5EARslpYg+TyZSoUkMEwIAv0+uL8vYpoAMBtc468voFgET05Evb7aT4MR4N0d5OBAxLJ+v/J5BK0WsLsrant7VHMfBZ6fgVwOWF8XKZfHfTnlEXx8ANfX4Pm5qPf3/1RMSYAEb26AoyNRT09uKicXYKMBOTwUVa97KZ/gDHQ6YDoNSSZFvDX3uAP9PnB5CV5difr89L4A1wJ2kJyeinp5mbSxO4ExQTIpDmfAOUimQviXU724SN7fh3E9/wZRf7qSuTNUpgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0wNS0wOVQxNTozNjo1MyswMDowMLvBGAwAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMDUtMDlUMTU6MzY6NTMrMDA6MDDKnKCwAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTA1LTA5VDE1OjM2OjUzKzAwOjAwnYmBbwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.3e59ee6b11dbe49fe9a6a138885b668b.svg";
export { ForwardRef as ReactComponent };